// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WgckJ","option":"styles_option__cuBHE","active":"styles_active__1tpmV"};